import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { Toaster } from "@flint/ui";
import { trpc, makeTrpcClient } from "./lib/trpc.ts";
import { makeQueryClient } from "./lib/query-client.ts";
import { NotFound, AppError } from "./features/errors/index.ts";
// `routeTree.gen.ts` is generated by @tanstack/router-plugin from src/routes/*.
// During the first build it produces an empty tree; the file is committed
// after the first successful run.
import { routeTree } from "./routeTree.gen.ts";
import "./styles/index.css";

const queryClient = makeQueryClient();
const trpcClient = makeTrpcClient();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  // Route-level overrides may still be set per-route, but every unmatched URL
  // and every uncaught render/loader error falls back to these.
  defaultNotFoundComponent: NotFound,
  defaultErrorComponent: AppError,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
  <StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </trpc.Provider>
  </StrictMode>,
);
